import { render, staticRenderFns } from "./ShimmerText.vue?vue&type=template&id=2f38d37b&scoped=true&"
import script from "./ShimmerText.vue?vue&type=script&lang=js&"
export * from "./ShimmerText.vue?vue&type=script&lang=js&"
import style0 from "./ShimmerText.vue?vue&type=style&index=0&id=2f38d37b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f38d37b",
  null
  
)

export default component.exports